const slugify = (text) => {
    const slug = text
        .toLocaleLowerCase()
        .trim()
        .replace(/[^\p{L}\p{N}]+/gu, '-');

    return slug.replace(/^-|-$/g, '') || 'section';
};

const createUniqueId = (heading, usedIds) => {
    const baseId = heading.id || slugify(heading.textContent);
    let id = baseId;
    let suffix = 2;

    while (usedIds.has(id)) {
        id = `${baseId}-${suffix}`;
        suffix += 1;
    }

    usedIds.add(id);
    return id;
};

const tableOfContents = () => {
    const content = document.querySelector('[data-post-content]');
    const toc = document.querySelector('[data-toc]');
    const tocList = document.querySelector('[data-toc-list]');

    if (!content || !toc || !tocList) {
        return;
    }

    const headings = [...content.querySelectorAll('h2, h3')];

    if (headings.length < 2) {
        toc.hidden = true;
        return;
    }

    const usedIds = new Set();
    const items = headings.map((heading) => {
        heading.id = createUniqueId(heading, usedIds);

        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        link.dataset.tocLink = heading.id;

        if (heading.tagName === 'H3') {
            item.classList.add('gh-toc-subitem');
        }

        item.append(link);
        tocList.append(item);

        return {heading, link};
    });

    const setActiveHeading = (activeHeading) => {
        items.forEach(({heading, link}) => {
            const isActive = heading === activeHeading;
            link.classList.toggle('is-active', isActive);

            if (isActive) {
                link.setAttribute('aria-current', 'location');
            } else {
                link.removeAttribute('aria-current');
            }
        });
    };

    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
            const visibleHeading = entries
                .filter((entry) => entry.isIntersecting)
                .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];

            if (visibleHeading) {
                setActiveHeading(visibleHeading.target);
            }
        }, {
            rootMargin: '-96px 0px -65% 0px',
            threshold: 0
        });

        headings.forEach((heading) => observer.observe(heading));
    }
};

export default tableOfContents;
